import React, { useEffect, useRef, useState } from "react";
import "./rateandrules.css";
import Modal from "react-modal";
import { MdKeyboardArrowDown } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { FaCalculator } from "react-icons/fa6";


const RateAndRules = () => {
  const [isModalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const [selectedOption, setSelectedOption] = useState("Original Games (28%)");
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);
  const [wager, setWager] = useState(1000);
  const [commissionRate, setCommissionRate] = useState(25);
  const [calculatedAmount, setCalculatedAmount] = useState(0);

  const dropdownRef = useRef(null);

  const options = [
    { label: "Original Games (28%)", value: 28 },
    { label: "Live Casino (60%)", value: 60 },
    { label: "3rd Party Slots (60%)", value: 60 },
    { label: "Sport Games (100%)", value: 100 },
  ];

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    setIsOptionsVisible(false);
    calculateAmount(wager, commissionRate, option.value);
  };

  const toggleOptions = () => {
    setIsOptionsVisible(!isOptionsVisible);
  };

  const calculateAmount = (wager, commissionRate, gamePercent) => {
    if (wager && commissionRate && gamePercent) {
      const result = (wager * commissionRate * gamePercent * 0.01) / 10000;
      setCalculatedAmount(result.toFixed(2)); // Keep 2 decimal places
    } else {
      setCalculatedAmount(0);
    }
  };

  useEffect(() => {
    const selectedGamePercent = options.find(
      (option) => option.label === selectedOption
    )?.value;
    calculateAmount(wager, commissionRate, selectedGamePercent);
  }, [wager, commissionRate, selectedOption]);


  const tableData = [
    { level: "VIP 04", score: 1000, reward: "+0.50", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules3.png" },
    { level: "VIP 08", score: 5000, reward: "+2.50", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules3.png" },
    { level: "VIP 14", score: 17000, reward: "+5.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules3.png" },
    { level: "VIP 22", score: 49000, reward: "+12.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules3.png" },
    { level: "VIP 30", score: 129000, reward: "+25.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules3.png" },
    { level: "VIP 38", score: 321000, reward: "+50.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules.png" },
    { level: "VIP 46", score: 769000, reward: "+80.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules.png" },
    { level: "VIP 54", score: 1793000, reward: "+120.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules.png" },
    { level: "VIP 62", score: 4097000, reward: "+205.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules.png" },
    { level: "VIP 70", score: 9217000, reward: "+500.00", icon: "/assets/bcimages/bcaffiliate/reward-table-rateandrules2.png" },
  ];

  return (
    <div>
      <div className="rateandrules-main">
        <div className="rateandrules-main-container">
          <div className="commision-rewardrate-calculator">
            <section className="commission-rewardrate-section">
              <h3 className="commission-rewardrate-title">
                Commission Reward Rate
              </h3>
              <div className="commission-rewardrate-content">
                <h3>Casino</h3>
                <div className="commission-rewardrate-divider">
                  <div className="commissionrate-original-games">
                    <p>The Original Games</p>
                    <div className="original-games-commmision">
                      <span className="text-color-change">Wager</span>
                      <span className="text-color-change">× 1% ×</span>
                      <span className="text-not-change">Commission Rate</span>
                      <span className="text-color-change">×</span>
                      <span className="text-not-change">28%</span>
                    </div>
                  </div>
                  <div className="commissionrate-original-games">
                    <p>3rd Party Slots, Live Casino</p>
                    <div className="original-games-commmision">
                      <span className="text-color-change">Wager</span>
                      <span className="text-color-change">× 1% ×</span>
                      <span className="text-not-change">Commission Rate</span>
                      <span className="text-color-change">×</span>
                      <span className="text-not-change">60%</span>
                    </div>
                  </div>
                </div>
                <div className="commissionrate-original-games">
                  <h3>All Sports</h3>
                  <div className="original-games-commmision">
                    <span className="text-color-change">Wager</span>
                    <span className="text-color-change">× 1% ×</span>
                    <span className="text-not-change">Commission Rate</span>
                    <span className="text-color-change">×</span>
                    <span className="text-not-change">100%</span>
                  </div>
                </div>
                <div className="view-rules-btn">
                  <button onClick={toggleModal}>
                    <span>View Rules</span>
                    <MdKeyboardArrowDown size={18} />
                  </button>
                </div>
              </div>
            </section>
            <section className="commission-calculator-section">
              <div className="commission-calculator-top">
                <div className="commission-calculator-top-title">
                <FaCalculator/>
                  <p>Commission Calculator</p>
                </div>
                <div>
                  <span>USDT</span>
                </div>
              </div>
              <div className="commission-calculator-bottom">
                <div className="commission-calculate-section">
                  <div className="calculator-amount-input">
                    <span>Wager (USDT)</span>
                    <div className="calculator-amount-input-main">
                      <input
                        type="number"
                        value={wager}
                        onChange={(e) => setWager(e.target.value)}
                      />
                    </div>
                  </div>
                  <span className="calculator-amount-span">× 1% ×</span>
                  <div className="calculator-amount-input">
                    <span>Commission Rate</span>
                    <div className="calculator-amount-input-main">
                      <input
                        type="number"
                        value={commissionRate}
                        onChange={(e) => setCommissionRate(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
                <div className="commission-calculate-game" ref={dropdownRef}>
                  <span>Game</span>
                  <button
                    onClick={toggleOptions}
                    className="main-select-button"
                  >
                    {selectedOption}
                    <div className="calculate-game-select">
                      <MdKeyboardArrowDown size={20} />
                    </div>
                  </button>
                  {isOptionsVisible && (
                    <div className="games-select-options">
                      <div className="games-select-container">
                        {options.map((option) => (
                          <button
                            key={option.value}
                            className={`games-select-button ${
                              selectedOption === option.label ? "active" : ""
                            }`}
                            onClick={() => handleOptionClick(option)}
                          >
                            {option.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
                <div className="total-calculate-amount">
                  <span className="equal-sign">=</span>
                  <span className="total-amount">{calculatedAmount} USDT</span>
                </div>
              </div>
            </section>
          </div>
          <section className="friend-refferal-reward-section">
            <h3>How to Get your Referral Reward</h3>
            <div className="friend-refferal-rewards">
              <div className="share-to-friends-main">
                <div className="share-to-friends-left">1</div>
                <div className="share-to-friends-right">
                  <span className="share-friend-span-1">Share</span>
                  <span
                    className="share-friend-span-2"
                    style={{ paddingLeft: "5px" }}
                  >
                    to friends
                  </span>
                  <br />
                  <p>Share your referral link or code to your friends</p>
                </div>
              </div>
              <div className="share-to-friends-main">
                <div className="share-to-friends-left">2</div>
                <div className="share-to-friends-right">
                  <span className="share-friend-span-2">Get</span>
                  <span
                    style={{ paddingLeft: "5px" }}
                    className="share-friend-span-1"
                  >
                    $1000
                  </span>
                  <br />
                  <p>Your awards will be locked for now</p>
                </div>
              </div>
              <div className="share-to-friends-main">
                <div className="share-to-friends-left">3</div>
                <div className="share-to-friends-right">
                  <span className="share-friend-span-2">Level Up &</span>
                  <span
                    className="share-friend-span-1"
                    style={{ paddingLeft: "5px" }}
                  >
                    Receive
                  </span>
                  <br />
                  <p>
                    Your friend’s VIP level will unlock your awards (see rules
                    below)
                  </p>
                </div>
              </div>
            </div>
            <table className="friend-refferal-table">
              <thead>
                <tr>
                  <th className="text-left">Friend’s Level</th>
                  <th>Total Wager</th>
                  <th className="text-right">Unlock Amount</th>
                </tr>
              </thead>
              <tbody className="table-body-refferel">
      {tableData.map((row, index) => (
        <tr key={index}>
          <td className="text-left friend-level-td">
            <img style={{ width: "1rem", height: "1.25rem" }} src={row.icon} alt="icon" />
            <span>{row.level}</span>
          </td>
          <td>{row.score}</td>
          <td className="text-right">{row.reward}</td>
        </tr>
      ))}
              </tbody>
            </table>
          </section>
        </div>
      </div>

      {/* refferal Modal Component */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Referral Terms & Conditions"
        className="games-and-casino-commision-rule"
        overlayClassName="custom-overlay"
      >
        <h2>Rules</h2>
        <button onClick={toggleModal} className="close-modal-button">
          <RxCross2 />
        </button>
        <div
          className="modal-content-affiliate"
        >
          <p>
            In any public environment (eg, universities, schools, libraries, and
            office spaces), only one commission can be paid to each user, IP
            address, electronic device, home, phone number, billing method,
            email address, and computer and IP address shared with others.
          </p>
          <p style={{ marginTop: "20px" }}>
            Our decision to draw a bet will be based entirely on our discretion
            after a deposit is made and a bet is successfully placed.
          </p>
          <p style={{ marginTop: "20px" }}>
            We support the majority of currencies on the market. Commissions can
            be withdrawn into our internal BCgame wallet at anytime. (View your
            commission extraction in the dashboard and view the balance in the
            wallet).
          </p>
          <p style={{ marginTop: "20px" }}>
            The system calculates the commission every 24 hours.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default RateAndRules;
